module.exports = __webpack_public_path__ + "media/images/writer/community/sp-title@3x-d9c81a62b7bfd2893decabad932ae070.png";